/*@flow*/
type Record = { [key: string]: string | number | void };

export default function(dataObject: Record): string {
  const dataArray = [];
  Object.keys(dataObject).forEach(key => {
    const v = dataObject[key];
    const value = v === null || v === undefined ? '' : v.toString();
    let result = value.replace(/"/g, '""');
    result = result.match(',') ? '"' + result + '"' : result;
    dataArray.push(result);
  });
  return dataArray.join(',') + '\r\n';
}
